




















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'Gallery'
})
export default class Gallery extends Vue {
    @Prop({ required: true })
    public images!: string[];

    @Prop({ required: true })
    public title!: string;

    public dialog = false;
}
